// extracted by css-extract-rspack-plugin
export default {"root":"t52Lsf","product-type":"SfqFHq","productType":"SfqFHq"};